import { UserRoles } from '@/enums/UserRoles'
import { ConfigMenuNames } from '@/common/enums/ConfigMenuNames';

export default {
  computed: {
    isPedestrian() {
      return Boolean(
        this.visitor.transports && (
          this.visitor.transports.length < 1 ||
          this.visitor.transports[0].type === 'pedestrian'
        )
      )
    },

    visibleCloseButton() {
      return Boolean(this.user && this.cfgMenuVisitor.give_access_visitor)
    },

    visibleVisitorIssuePassButton() {
      return Boolean(
        this.visitor.access === 0 && (
          this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS] ||
          this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_ONE] ||
          this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERMANENT]) &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD]
      )
    },

    visibleVisitorIssuePassPeriodButton() {
      return this.visitor.access === 0 &&
        this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS]
    },

    visibleVisitorPrintPassButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERMANENT] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_ONE] &&
        this.visitor.personal.isIssued
      )
    },

    visibleVisitorPrintPassPeriodButton() {
      return this.visitor.access === 0 &&
          this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD] &&
          !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS] &&
          !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_ONE] &&
          !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERMANENT] &&
          this.visitor.personal.isIssued
    },

    visibleVisitorPrintPassPermanentAsOneButton() {
      return this.visitor.access === 0 &&
        this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_ONE] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        this.visitor.personal.isIssued
    },
    visibleVisitorPrintPassPermanentButton() {
      return this.visitor.access === 0 &&
        this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERMANENT] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        this.visitor.personal.isIssued
    },

    visibleVisitorSendToSolvoButton() {
      return Boolean(this.visitor.access === 0 && this.cfgMenuVisitor[ConfigMenuNames.SEND_TO_SOLVO])
    },

    visibleVisitorSendToScudButton() {
      return Boolean(this.visitor.access === 0 && this.cfgMenuVisitor[ConfigMenuNames.SEND_TO_SCUD] && !this.inScud)
    }
  }
}
